export default __webpack_public_path__ + "static/media/fleet-efficiency.5a56ae25.svg";